module.exports = __webpack_public_path__ + "static/media/img28.a2bb2b38.jpg";